import type { RowData } from "@tanstack/react-table";
import {
	CustomTableWrapper,
	type CustomTableWrapperProps,
} from "./CustomTableWrapper";

export type TableViewProps<TData extends RowData> =
	CustomTableWrapperProps<TData>;

/**
 * Figma TableView — full list composition (search/filters, table, pagination).
 * Thin presentational alias over `CustomTableWrapper` for DS naming and Code Connect.
 *
 * @see Figma TableView 3101:15017 (Populated Desktop 3101:15094)
 */
export function TableView<TData extends RowData>(props: TableViewProps<TData>) {
	return <CustomTableWrapper {...props} />;
}
